module.exports = __webpack_public_path__ + "static/img/3.e1e88ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/3.png
// module id = 2Gkb
// module chunks = 0